import z from '@/lib/zod';

const passwordSchema = z
    .string()
    .min(8, 'Password must be at least 8 characters long')
    .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
    .regex(/[0-9]/, 'Password must contain at least one number')
    .regex(
        /[^A-Za-z0-9]/,
        'Password must contain at least one special character',
    );

const emailSchema = z.email().toLowerCase().trim();

const nameSchema = z
    .string()
    .trim()
    .min(1, 'Full name is required')
    .max(50, 'Full name is too much long.');

export const CredentialsLoginFormSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, 'Password is required'),
});

export const OnlyEmailSchema = z.object({
    email: z
        .email({ error: 'Invalid email address' })
        .toLowerCase()
        .trim()
        .optional()
        .or(z.literal(''))
        .transform((value) => (value === '' ? undefined : value)),
});

export const PrimaryEmailSchema = z.object({
    primaryEmail: emailSchema,
});

export const UserDataSchema = z.object({
    name: nameSchema,
});

export const ResetPasswordSchema = z
    .object({
        password: passwordSchema,
        confirmPassword: passwordSchema,
    })
    .superRefine((data, ctx) => {
        if (data.password !== data['confirmPassword']) {
            ctx.addIssue({
                code: 'custom',
                message:
                    'New password and confirm new password fields do not match',
                path: ['password'],
            });

            ctx.addIssue({
                code: 'custom',
                message:
                    'Confirm new password and new password fields do not match',
                path: ['confirmPassword'],
            });
        }
    });

export const ChangePasswordSchema = z
    .object({
        oldPassword: passwordSchema,
    })
    .and(ResetPasswordSchema);

export const ForgotPasswordSchema = z.object({
    email: emailSchema,
});

export const SignUpSchema = z
    .object({
        name: nameSchema,
        email: emailSchema,
    })
    .and(ResetPasswordSchema);

export const MFATotpEnableSchema = z.object({
    code: z.string().min(6, {
        message: 'Your one-time pin code must be 6 digits.',
    }),
});
